import { render, staticRenderFns } from "./StandardIndex.vue?vue&type=template&id=0d12cbd4"
import script from "./StandardIndex.vue?vue&type=script&lang=js"
export * from "./StandardIndex.vue?vue&type=script&lang=js"
import style0 from "./StandardIndex.vue?vue&type=style&index=0&id=0d12cbd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports